import { render } from "./ExtraView.vue?vue&type=template&id=7f5337e2&scoped=true&ts=true"
import script from "./ExtraView.vue?vue&type=script&lang=ts"
export * from "./ExtraView.vue?vue&type=script&lang=ts"

import "./ExtraView.vue?vue&type=style&index=0&id=7f5337e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5337e2"]])

export default __exports__